import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

// Your prod web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyAjXx90kU7WjKKpGKQW8Gi1I-5Jip2FSgo",
  authDomain: "hrs-events-5a2ea.firebaseapp.com",
  projectId: "hrs-events-5a2ea",
  storageBucket: "hrs-events-5a2ea.appspot.com",
  messagingSenderId: "242000479310",
  appId: "1:242000479310:web:b03c27d54683e5c6bf6f1f",
  measurementId: "G-G57427XXPJ"
};

// Your stage web app's Firebase configuration
/*var firebaseConfig = {
  apiKey: "AIzaSyDH-SwLO2tt-iEfNH5b0p0ksJD5b5YfMZ0",
  authDomain: "wp-hrs-events.firebaseapp.com",
  projectId: "wp-hrs-events",
  storageBucket: "wp-hrs-events.appspot.com",
  messagingSenderId: "491806964521",
  appId: "1:491806964521:web:f40ad32403eab50c68d538",
  measurementId: "G-LLT4FZQBDN"
};*/
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.firestore().settings({ timestampsInSnapshots: true, merge: true });

export default firebase;
